<template>
  <div class="screen-container">
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <v-layout v-else column>
      <v-flex class="title-screen" xs12>
        <span>Past Events</span>
      </v-flex>
      <div v-if="!allEvents.length" class="no-events-container">
        <img src="/assets/no-past-events.svg" alt="No past events" style="max-width: 100%">
        <p>You don't have any past events.</p>
      </div>
      <div v-else>
        <text-field
          label="Search Your Past events"
          append-icon="search"
          style="max-width: 24.0625rem; margin-bottom: 2.5rem;"
          @input="onSearchChange"
        />
        <div v-if="allEvents.length" class="event-container">
          <event-card
            v-for="event in events"
            :key="event.id"
            :event="event"
            :organization-type="organizationType"
            :organization-slug="organizationSlug"
          />
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import { GET_EVENTS_AND_QUOTA } from '@/graphql/event.graphql'
import { OrganizationType, SeatState } from '@/types'
import eventCard from '../../events/event-card.vue'
import { uniqBy } from 'lodash'
import sumBy from 'lodash/sumBy'

export default {
  name: 'organization-past-events-list-container',
  components: { eventCard },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      events: [],
      allEvents: [],
      OrganizationType,
      organizationType: OrganizationType.REGULAR,
    }
  },
  methods: {
    getPastEvents(eventList) {
      return eventList
        .sort((event1, event2) => new Date(event2.from) - new Date(event1.from))
    },
    onSearchChange(input) {
      this.events = this.allEvents.filter(event => event.title.toLowerCase().includes(input.toLowerCase()))
    },
  },
  apollo: {
    getEvents: {
      query: GET_EVENTS_AND_QUOTA,
      variables() {
        return { organizationSlug: this.organizationSlug, filter: 'past' }
      },
      result({ data: { getEvents, getOrganization }, loading }) {
        if (!loading) {
          this.organizationType = getOrganization.type
          if (this.organizationType === this.OrganizationType.THEATER) {
            const pastPerformances = this.getPastEvents(getEvents || [])
            const pastEventTemplates = uniqBy(
              pastPerformances.map(({ eventTemplate, extraModules, from, to }) => {
                return { ...eventTemplate, extraModules, from, to }
              }),
              'id',
            )
            this.events = pastEventTemplates.map(eventTemplate => {
              const performances = pastPerformances.filter(performance => performance.eventTemplate.id === eventTemplate.id)
              const totalTicketsSold = sumBy(performances, performance => performance.totalTicketsSold)
              const totalNumberOfTickets = sumBy(performances, performance => performance.totalNumberOfTickets)
              const totalEarnings = sumBy(performances, performance => performance.totalEarnings)
              const cover = performances.length ? performances[0].cover : null

              return {
                ...eventTemplate,
                totalTicketsSold,
                totalNumberOfTickets,
                totalEarnings,
                cover,
              }
            })
          } else {
            this.events = this.getPastEvents(getEvents || [])
          }
          this.allEvents = this.events
        }
      },
    },
  },
}
</script>

<style scoped>
.event-container {
  display: flex;
  flex-direction: column;
  max-width: 42.75rem;
  gap: 1rem;
}
@media screen and (max-width: 560px) {
  .event-container {
    max-width: 100%;
  }
}

::v-deep .v-messages{
  display: none;
}
::v-deep .v-input__slot {
  margin: 0;
}

.no-events-container {
  margin: 20vh auto 0 auto;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  color: #979797;
  text-align: center;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
